"use client";

import { PunchupToggle } from "@punchup/ui-common/punchup/primitives/forms/fields/PunchupToggle";

export interface ZeroLineupExperimentControls {
  includeZeroLineup: boolean;
  onToggle: () => void;
}

const TOGGLE_ID = "shows-nearby-include-zero-lineup";

/**
 * The internal-only switch behind the `shows_nearby_zero_lineup_toggle` gate:
 * on, the page asks /api/shows for shows with an empty lineup and renders
 * them under their own title instead of a comedian.
 */
export default function ShowsNearbyZeroLineupToggle({
  includeZeroLineup,
  onToggle,
}: ZeroLineupExperimentControls) {
  return (
    <div className="flex flex-row items-center gap-3">
      <PunchupToggle
        name={TOGGLE_ID}
        isChecked={includeZeroLineup}
        handleClick={onToggle}
        aria-label="Include shows without a lineup"
      />
      <label htmlFor={TOGGLE_ID} className="text-sm font-medium cursor-pointer">
        Include shows without a lineup{" "}
        <span className="text-neutral-500 font-normal">
          (internal experiment)
        </span>
      </label>
    </div>
  );
}
